import { useEffect, useRef, useState } from 'react'
import { Icon } from '../ui/Icon'

/**
 * The bar's Close for a bare terminal — owner, 2026-10-18: 使用者可以隨時將這個 Terminal 關閉.
 *
 * Two taps, like the rail's ✕ on the same rows: the first arms it and says what the second
 * will do, the second ends the session, and three seconds of hesitation disarm it. A shell may
 * be in the middle of something, and one slip of a finger must not end it.
 */
export function CloseTerminalButton({ label, onClose }: { label: string; onClose: () => Promise<void> }) {
  const [armed, setArmed] = useState(false)
  const [busy, setBusy] = useState(false)
  const timer = useRef<number | null>(null)
  const disarm = () => {
    if (timer.current !== null) window.clearTimeout(timer.current)
    timer.current = null
  }
  useEffect(() => disarm, [])
  return (
    <button
      type="button"
      id="termCloseBtn"
      className={`right${armed ? ' armed' : ''}`}
      title={armed ? 'Tap again to close this terminal' : 'Close terminal'}
      aria-label={armed ? `Confirm: close the terminal in ${label}` : `Close the terminal in ${label}`}
      disabled={busy}
      onClick={() => {
        disarm()
        if (!armed) {
          setArmed(true)
          timer.current = window.setTimeout(() => setArmed(false), 3000)
          return
        }
        setArmed(false)
        setBusy(true)
        void onClose().finally(() => setBusy(false))
      }}
    >
      {armed ? 'Close?' : <Icon name="close" size={17} label="Close terminal" />}
    </button>
  )
}
